<template>
  <div v-if="isShow" class="ov on" @click.self="close">
    <div class="dlg wide" role="dialog" aria-labelledby="new-sl-title" @click.stop>
      <div class="dwh">
        <div>
          <div id="new-sl-title" class="dwt">New Smart Link</div>
          <span class="dws">Create a campaign, then add ad sets and offers in the workspace</span>
        </div>
        <span class="grow"></span>
        <button type="button" class="dwx" @click="close">✕</button>
      </div>
      <div class="dwb">
        <div class="grp">
          <div class="grph">Smart link setup</div>
          <div class="grpb one">
            <div class="fgrid">
              <div class="frow full">
                <div class="flab">Name</div>
                <div class="fbody">
                  <input class="ti w-xl" v-model.trim="form.name" placeholder="Smart link name" autofocus>
                </div>
              </div>
              <div class="frow full">
                <div class="flab">Frequency</div>
                <div class="fbody">
                  <FreqSeg :value="form.frq" @input="form.frq = $event" />
                </div>
              </div>
              <div class="frow full">
                <div class="flab">IP Frequency</div>
                <div class="fbody">
                  <FreqSeg :value="form.ip_frq" @input="form.ip_frq = $event" />
                </div>
              </div>
              <div class="frow">
                <div class="flab">IP Frequency Level</div>
                <div class="fbody">
                  <select class="ti" v-model="form.ip_frq_level">
                    <option v-for="l in ipLevels" :key="l.value" :value="l.value">{{ l.text }}</option>
                  </select>
                  <button class="qmark" type="button" title="Composite key precision. Level 1 = broadest, Level 5 = strictest." @click.stop="showLegend = true">?</button>
                </div>
              </div>
              <div class="frow full">
                <div class="flab">Fallback URL</div>
                <div class="fbody">
                  <input class="ti w-xl" v-model.trim="form.fallback_url" placeholder="https://…">
                  <span class="hint">If empty, fallback goes to https://google.com</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dwf">
        <span class="grow"></span>
        <button class="btn" type="button" :disabled="busy" @click="close">Cancel</button>
        <button class="btn primary" type="button" :disabled="busy || !canCreate" @click="submit">
          {{ busy ? 'Creating…' : 'Create Smart Link' }}
        </button>
      </div>
    </div>
    <FrqModal :is-show.sync="showLegend" />
  </div>
</template>

<script>
import FreqSeg from './FreqSeg.vue'
import FrqModal from '../../../../../components/FrqModal.vue'
import { IP_FRQ_LEVELS } from '../../v2/status'

const DEFAULT_FALLBACK = 'https://impression.appsflyer.com/id1641486558?pid=flix8ki_int&af_siteid={aff_id}&af_c_id={offernum}&af_click_lookback=7d&clickid={imp_id}&c=summer2026&af_sub_siteid={plc5}&af_channel=inapp_vid&af_ad_type=banner&af_adset={plc2}&af_adset_id=&af_ad={plc8}&af_ad_id={plc1}&af_media_type=app&af_cost_currency=usd&af_cost_model=cpm&af_ua={UA}&af_os={OS}&af_ip={}&android_id={AID}&idfa={IID}&is_retargeting=true&af_reengagement_window=1d&af_inactivity_window=10d&af_os_version={os_ver}'

function emptyForm(isVta) {
  return {
    name: '',
    description: null,
    notes: null,
    frq: 0,
    ip_frq: 0,
    is_vta: !!isVta,
    ip_frq_level: 'l3',
    fallback_url: DEFAULT_FALLBACK
  }
}

export default {
  name: 'NewCampaignV2',
  components: { FreqSeg, FrqModal },
  props: {
    isShow: { type: Boolean, default: false },
    isVta: { type: Boolean, default: false }
  },
  data() {
    return {
      form: emptyForm(this.isVta),
      ipLevels: IP_FRQ_LEVELS,
      showLegend: false,
      busy: false
    }
  },
  computed: {
    canCreate() {
      return !!(this.form.name && this.form.name.trim())
    }
  },
  watch: {
    isShow(on) {
      if (on) this.form = emptyForm(this.isVta)
    }
  },
  methods: {
    close() {
      if (this.busy) return
      this.$emit('close')
    },
    async submit() {
      if (!this.userHasPermission('smartlinks.edit') || this.busy || !this.canCreate) return
      const form = Object.assign({}, this.form)
      try {
        await this.$validate.smartlinks.campaign(form)
      } catch (err) {
        this.notifyError(err.msg || 'Please fill in a name')
        return
      }
      this.busy = true
      try {
        const r = await this.$http.post(this.resources.SmartLinksCampaigns.postCampaign, form)
        const created = await r.json()
        created.stats = created.stats || {}
        const camps = this.$store.state.smartlinks
        if (!camps.campaigns) camps.campaigns = [created]
        else camps.campaigns.unshift(created)
        this.$emit('close')
        this.$router.push({
          name: 'SmartLinksV2Workspace',
          params: { campId: created.id }
        })
      } catch (err) {
        this.notifyError('Could not create Smart Link')
      }
      this.busy = false
    }
  }
}
</script>
